/**
 * YouTube facade — replaces a poster button with the real iframe only on click,
 * so the heavy YouTube embed never loads until the visitor wants to play.
 */
export function youtubeFacade() {
  document.querySelectorAll('[data-youtube]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.youtube;
      if (!id) return;
      const wrap = btn.closest('[data-yt-wrap]') || btn.parentElement;
      const title = (btn.getAttribute('aria-label') || 'YouTube video').replace(/"/g, '');
      wrap.innerHTML =
        `<iframe class="absolute inset-0 h-full w-full" ` +
        `src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0" ` +
        `title="${title}" frameborder="0" ` +
        `allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ` +
        `allowfullscreen></iframe>`;
    });
  });
}
